// @module SA.ShopperApproved.ShopperApprovedModuleFooter
define('SA.ShopperApproved.ShopperApprovedModuleFooter.View',	[
	'sa_shopperapproved_shopperapprovedmodule_footer.tpl',	'Backbone'
], function (
	sa_shopperapproved_shopperapprovedmodule_footer_tpl, Backbone
) {
    'use strict';

	// @class SA.ShopperApproved.ShopperApprovedModuleFooter.View @extends Backbone.View
	return Backbone.View.extend({

		template: sa_shopperapproved_shopperapprovedmodule_footer_tpl
        
	});
});
